// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "2.9.1-rc3-49-g18809002-dirty",
    "hash": "g18809002",
    "distance": 49,
    "tag": "2.9.1-rc3",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "2.9.1-rc3",
        "major": 2,
        "minor": 9,
        "patch": 1,
        "prerelease": [
            "rc3"
        ],
        "build": [],
        "version": "2.9.1-rc3"
    },
    "suffix": "49-g18809002-dirty",
    "semverString": "2.9.1-rc3+49.g18809002",
    "date": "2025-02-06T17:18:54.806Z"
};
/* tslint:enable */
